import { render, staticRenderFns } from "./StockAlert.vue?vue&type=template&id=d71b56aa"
import script from "./StockAlert.vue?vue&type=script&lang=js"
export * from "./StockAlert.vue?vue&type=script&lang=js"
import style0 from "./StockAlert.vue?vue&type=style&index=0&id=d71b56aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports